import(/* webpackMode: "eager" */ "/app/src/app/[locale]/story/[...story]/layout.module.sass");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AccessibilityMenu/AccessibilityMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageGradientBackground","BackgroundOverlay"] */ "/app/src/components/Background/Background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeItem"] */ "/app/src/components/HomeItems/HomeItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/1.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/2.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/3.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/4.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/ai-machine.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/bubbel.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/fantasie-ai.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/klokko-boodschappen.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/krabbel-machine.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/poezie-ai.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/vriendelijk-communiceren.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/werkstuk.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Page/PageNavigationButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/StoryIntro/StoryIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubjectProgressFromPageId"] */ "/app/src/components/Subject/SubjectProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["deleteAllUserSingleLargeValuesForSubject"] */ "/app/src/hooks/useBlockLocalUserData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/hooks/useLocalStorage.ts");
